import React, { useEffect, useState } from 'react';
import { AlertCircle, LogOut, RefreshCw } from 'lucide-react';
import './SessionWarning.css';

interface SessionWarningProps {
    minutesRemaining: number;
    onStayLoggedIn: () => void;
    onLogout: () => void;
}

const SessionWarning: React.FC<SessionWarningProps> = ({
    minutesRemaining,
    onStayLoggedIn,
    onLogout,
}) => {
    const [timeLeft, setTimeLeft] = useState(minutesRemaining);

    useEffect(() => {
        setTimeLeft(minutesRemaining);
    }, [minutesRemaining]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 0) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 60000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="session-warning-overlay">
            <div className="session-warning-modal">
                <div className="session-warning-icon">
                    <AlertCircle size={48} />
                </div>

                <h2 className="session-warning-title">Session Expiring Soon</h2>

                <p className="session-warning-message">
                    Your session will expire in{' '}
                    <strong>{timeLeft} {timeLeft === 1 ? 'minute' : 'minutes'}</strong>.
                </p>

                <p className="session-warning-subtitle">
                    Would you like to stay logged in?
                </p>

                <div className="session-warning-actions">
                    <button
                        className="session-warning-btn session-warning-btn-primary"
                        onClick={onStayLoggedIn}
                    >
                        <RefreshCw size={18} />
                        Stay Logged In
                    </button>

                    <button
                        className="session-warning-btn session-warning-btn-secondary"
                        onClick={onLogout}
                    >
                        <LogOut size={18} />
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SessionWarning;
